var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-collection"},[_c('ProductCards',{staticClass:"home-collection__cards",attrs:{"products":_vm.section.collection.products.slice(0, 3),"mode":"home"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }